export const CARDS = 'cards';
export const ACCOUNTS = 'accounts';
export const CARD = 'card';
export const ACCOUNT = 'account';
export const MAIN_CA_SCREEN = 'main ca screen';
export const LINKED_ACCOUNT = 'linked account';
export const FRAUD_SOFT_BLOCK = 'soft_block';
export const FRAUD_HARD_BLOCK = 'hard_block';
export const IDENTITY = 'identity';
export const INCOME_ADDRESS = 'income_address';
export const TRANSFER = 'transfer';
export const BANNER = 'banner';
export const OLD = 'old';
export const NEW = 'new';
export const GLOBAL_ACCOUNT = 'Global Account';
export const ADD_NEW_CARD = 'Add New Card';
export const USE_LINKED_CARD = 'Use Linked Card';
export const DRAFT = 'draft';
export const REPEAT = 'repeat';
export const RECIPIENT = 'recipient';
export const RESUME = 'resume';
export const INDIVIDUAL = 'individual';
export const SUMSUB = 'sumsub';
export const PAYMENT = 'payment';
export const DELIVERY = 'delivery';
export const CLOSE_TO_LIMIT = 'close_to_limit';
export const CALCULATOR = 'calculator';
export const PAYMENT_CONFIRMATION = 'payment_confirmation';
export const DOB = 'DOB';
export const SELF = 'self';
export const BUSINESS = 'business';
export const COUNTRY_AND_METHOD = 'country_and_method';
export const DELIVERY_METHOD_LIST = 'delivery_method_list';
export const SENDING_METHOD = 'sending_method';
export const CUSTOM = 'custom';
export const METHOD_SUGGESTION = 'method_suggestion';
export const METHOD_INVITATION = 'invitation';
export const CA_TOS = 'ca_tos';
export const CA_FACIAL_SCAN = 'ca_facial_scan';
export const US_TOS = 'us_tos';
export const US_ESING = 'us_esign';
export const ONBOARDING = 'onboarding';
export const MAIN_SCREEN = 'main_screen';
export const PROFILE = 'profile';
export const SDD = 'SDD';
export const HARDBLOCK = 'hardblock';
export const LOGIN = 'login';
export const SIGNUP = 'signup';

export const topUpMethods = {
    BANK_CARD: 'card',
    BANK_TRANSFER: 'bank transfer',
    APPLE_PAY: 'apple pay',
    GOOGLE_PAY: 'google pay',
    SALARY: 'salary',
};

export const requestPaymentMethods = {
    CARD: 'card',
    NEW_CARD: 'new_card',
    ACCOUNT: 'account',
    GLOBAL_ACCOUNT: 'global_account',
    NEW_ACCOUNT: 'new_account',
};

export const cardType = {
    PLASTIC: 'plastic',
    VIRTUAL: 'virtual',
};
